import React, { FC } from 'react';

import { useLang } from 'hooks';
import { Search } from 'components/icons';
import { Input } from 'components/ui';
import { InputProps } from 'types/components';

const SearchInput: FC<InputProps> = ({
  type = 'search',
  placeholder,
  prefix = <Search />,
  allowClear = true,
  ...props
}) => {
  const lang = useLang();

  return (
    <Input
      type={type}
      placeholder={placeholder ?? lang.get('common.actions.search')}
      prefix={prefix}
      allowClear={allowClear}
      {...props}
    />
  );
};

export default SearchInput;
